import './QuantitativeSamplesTable.css';

import React from 'react';
import { toLocaleDateTime } from '../../../b2b-common/helpers';
import Status from '../../components/Status';
import Trend from '../../components/Trend';
import B2BTableInMemory from '../../../b2b-common/B2BTableInMemory';
import { Add } from '@mui/icons-material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

export const renderSampleStatusAndTrend = (sample) => {
    return (
        <div className='sample-status-and-trend'>
            <Status status={sample.status} showLabel={false} />
            <Trend trend={sample.trend} showLabel={false} />
        </div>
    );
}

const QuantitativeSamplesTable = ({ areaIndicator, onSampleClick, onNewSample = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const headers = [
        { label: t('Sample Date'), align: 'center' },
        { label: t('Value'), align: 'center' },
        { label: t('Status'), align: 'center' },
    ];

    const rows = areaIndicator ? areaIndicator.sampleDTOs.map((sample) => ({
        id: sample.sampleId,
        cells: [
            { content: toLocaleDateTime(sample.sampleDate, true), align: 'center' },
            ...(areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit !== '' ?
                [{ content: `${sample.quantitativeValue} ${areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit}`, align: 'center' }] :
                [{ content: `${sample.quantitativeValue}`, align: 'center' }]),
            { content: renderSampleStatusAndTrend(sample), align: 'center' },
        ],
    })) : [];

    const handleRowClick = (row) => {
        if (onSampleClick) {
            onSampleClick(areaIndicator.sampleDTOs.find(sample => sample.sampleId === row.id));
        }
    };

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            numRows={10}
            className={'quantitative-samples-table'}
            onRowClick={handleRowClick}
            buttons={
                [
                    {
                        label: t('New Sample'),
                        icon: <Add />,
                        onClick: onNewSample,
                    }
                ]
            }
        />
    );
}

export default QuantitativeSamplesTable;